import { render } from "./attInformation.vue?vue&type=template&id=5159fa7f&scoped=true"
import script from "./attInformation.vue?vue&type=script&lang=js"
export * from "./attInformation.vue?vue&type=script&lang=js"

import "./attInformation.vue?vue&type=style&index=0&id=5159fa7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5159fa7f"]])

export default __exports__